import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AccountsDropdown from './AccountsDropdownComponent';
import { selectAccount } from '@alphapoint/apex-web/lib/redux/actions/userActions';
import { defaultAccountSelector, accountsSelector } from '@alphapoint/apex-web/lib/redux/margin/selectors';

const mapStateToProps = (state) => {
  const { selectedAccountId } = state.user;
  const accounts = accountsSelector(state);
  let selectedAccount = accounts.find((account) => account.AccountId === selectedAccountId);

  if (!selectedAccount) {
    selectedAccount = defaultAccountSelector(state);
  }

  return {
    accounts,
    selectedAccount,
  };
};

const mapDispatchToProps = {
  selectAccount,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountsDropdown));
